module.exports = __webpack_public_path__ + "images/453201f9cfeeab03370eac8965e2b9a0.png";